import React from 'react';
import { PersistGate } from 'redux-persist/integration/react';
import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { MuiThemeProvider } from '@material-ui/core/styles';
import configureStore from './store/configure.store';
import Application from './pages/index';
import theme from './resources/theme/q4.theme';

import './resources/styles/global.scss';

function init() {
  const { store, persistor } = configureStore();

  render(
    <Router>
      <MuiThemeProvider theme={theme}>
        <PersistGate loading={null} persistor={persistor}>
          <Application store={store} />
        </PersistGate>
      </MuiThemeProvider>
    </Router>,
    document.getElementById('root')
  );
}

init();
